import { gql } from '@src/lib/gql'

export const MY_ADVISOR_PROFILE = gql`
  query BecomeAdvisorMyProfile {
    myAdvisorProfile {
      id
      advisorProfileId
      statusKey
      isApproved
      categoryKeys
      warmIntroKeys
      availabilityHoursPerMonth
      headline
      bioForAdvising
      notableBrands
      engagementStyleKeys
      skillTagTitles
      advisingNote
      preferredCompensationTypeKeys
      sessionBookingUrl
      hourlyRate
      isSessionEnabled
      timezone
      sessionWeeklyHours
      sessionFeeWaiveCode
      canAcceptSessions
      stripeConnectStatusKey
      responsesCount
      foundersHelpedCount
      appliedAt
      approvedAt
      categories {
        id
        key
        title
      }
      warmIntros {
        id
        key
        title
      }
    }
  }
`
